/**
 * logger.js
 *
 * Tiny logging utility that no-ops debug calls in production.
 *
 *   - logger.log(...)  → console.log only in development
 *   - logger.warn(...) → console.warn only in development
 *   - logger.debug(...) → console.debug only in development
 *   - logger.error(...) → ALWAYS console.error (keeps prod errors visible
 *                         for browser dev-tools + future Sentry-style hookup)
 *
 * Use `logger` instead of `console` for any new code; keeps the prod console
 * clean while preserving error visibility.
 */
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
  error: (...args) => { console.error(...args); },
};
